import { WIDGET_IDS } from "../classes/constants/dashboardWidgetConstants";

export const defaultPatientDashboardLayout = [
  // Column 1
  {
    id: WIDGET_IDS.PERSONAL_INFO,
    column: 1,
    row: 1,
    title: "184",
    contentType: "personalInfo",
  },
  {
    id: WIDGET_IDS.CLINICAL_HISTORY,
    column: 1,
    row: 2,
    title: "185",
    contentType: "clinicalHistory",
  },
  // Column 2
  {
    id: WIDGET_IDS.PAIN_ASSESMENT,
    column: 2,
    row: 1,
    title: "186",
    contentType: "painAssessment",
  },
  {
    id: WIDGET_IDS.REPORTS,
    column: 2,
    row: 2,
    title: "76",
    contentType: "reports",
  },
  // Column 3
  {
    id: WIDGET_IDS.PATIENT_MORPHOLOGY,
    column: 3,
    row: "1 / 3",
    title: "187",
    contentType: "patientMorphology",
  },
  // Column 4
  {
    id: WIDGET_IDS.MEDICAL_IMAGE,
    column: 4,
    row: "1 / 3",
    title: "188",
    contentType: "medicalImage",
  },
];

export const noReportsPatientDashboardLayout = [
  // Column 1
  {
    id: WIDGET_IDS.PERSONAL_INFO,
    column: 1,
    row: 1,
    title: "184",
    contentType: "personalInfo",
  },
  {
    id: WIDGET_IDS.CLINICAL_HISTORY,
    column: 1,
    row: 2,
    title: "185",
    contentType: "clinicalHistory",
  },
  // Column 2
  {
    id: WIDGET_IDS.PATIENT_MORPHOLOGY,
    column: 2,
    row: 1,
    title: "187",
    contentType: "patientMorphology",
  },
  {
    id: WIDGET_IDS.PAIN_ASSESMENT,
    column: 2,
    row: 2,
    title: "186",
    contentType: "painAssessment",
  },
  // Columns 3 and 4
  {
    id: WIDGET_IDS.MEDICAL_IMAGE,
    column: "3 / 5",
    row: "1 / 3",
    title: "188",
    contentType: "medicalImage",
  },
];
